import axiosHttp from "./interceptor.service";

const postParentTask = (data) => {
  return axiosHttp.post("/lmt/createParentTask", data);
};

const getParentTask = ({search, limit, page, sort,projectId}= {}) => {
  console.log("Query Params:", search, limit, page, sort ,projectId);
  return axiosHttp.get("/lmt/getParentTask", {
    params: { search, limit, page, sort ,projectId},
  });
};

const getProjectParentTask = (id, { search } = {}) => {
  return axiosHttp.get(`/lmt/getProjectParentTask/${id}`, {
    params: { search },
  });
};

const updateParentTask = (id, data) => {
  return axiosHttp.put(`/lmt/updateParentTask/${id}`, data);
};
const changeParentTask = (id) => {
  return axiosHttp.get(`lmt/checkTask/${id}`);
};

const deleteParentTask = (id, data) => {
  return axiosHttp.delete(`/lmt/deleteParentTask/${id}`, data);
};

export {
  postParentTask,
  getParentTask,
  getProjectParentTask,
  updateParentTask,
  deleteParentTask,
  changeParentTask,
};
